const items = [
  {
    tag: '重磅深扒',
    title: '某顶流男星深夜密会神秘女子，酒店同框画面曝光',
    image: 'https://readdy.ai/api/search-image?query=Blurred%20paparazzi%20night%20shot%20of%20luxury%20hotel%20entrance%20with%20silhouettes%2C%20dramatic%20lighting%2C%20entertainment%20news%20style%2C%20dark%20atmosphere%20with%20warm%20street%20lights%2C%20mysterious%20and%20cinematic%20mood%2C%20soft%20focus%20background%2C%20editorial%20photography&width=600&height=400&seq=carousel-01&orientation=landscape',
    date: '2026-07-30',
    views: '128.6万',
  },
  {
    tag: '独家爆料',
    title: '知名女星合约纠纷内幕：千万违约金背后的资本博弈',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20contract%20documents%20on%20a%20dark%20wooden%20desk%20with%20dramatic%20shadows%2C%20a%20pen%20resting%20on%20paper%2C%20warm%20ambient%20lighting%20from%20a%20desk%20lamp%2C%20luxurious%20office%20setting%2C%20mysterious%20atmosphere%2C%20editorial%20photography%20style&width=600&height=400&seq=carousel-02&orientation=landscape',
    date: '2026-07-29',
    views: '96.3万',
  },
  {
    tag: '深度深扒',
    title: '选秀节目投票造假全记录：谁在操控你的偶像出道',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20stage%20with%20spotlights%20and%20voting%20screens%20in%20the%20background%2C%20dark%20backstage%20atmosphere%2C%20talent%20show%20production%20setting%2C%20mysterious%20silhouettes%2C%20high%20contrast%20lighting%2C%20entertainment%20industry%20theme%2C%20cinematic%20mood&width=600&height=400&seq=carousel-03&orientation=landscape',
    date: '2026-07-28',
    views: '215.8万',
  },
  {
    tag: '近日热点',
    title: '娱乐圈夫妻档离婚内幕流出：第三者身份引网友狂猜',
    image: 'https://readdy.ai/api/search-image?query=Split%20wedding%20rings%20on%20dark%20velvet%20surface%20with%20dramatic%20lighting%2C%20emotional%20atmosphere%2C%20warm%20but%20melancholy%20tones%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20intimate%20and%20mysterious%20mood&width=600&height=400&seq=carousel-04&orientation=landscape',
    date: '2026-07-27',
    views: '187.2万',
  },
  {
    tag: '独家揭秘',
    title: '某综艺录制现场冲突视频流出，导演组与嘉宾激烈对峙',
    image: 'https://readdy.ai/api/search-image?query=Film%20set%20with%20cameras%20and%20equipment%20in%20dramatic%20shadows%2C%20tense%20atmosphere%2C%20production%20crew%20silhouettes%2C%20warm%20studio%20lights%20creating%20dramatic%20contrast%2C%20behind%20the%20scenes%20aesthetic%2C%20entertainment%20industry%20photography&width=600&height=400&seq=carousel-05&orientation=landscape',
    date: '2026-07-26',
    views: '156.4万',
  },
  {
    tag: '最新爆料',
    title: '当红小花被曝片场耍大牌，多位剧组工作人员佐证实锤',
    image: 'https://readdy.ai/api/search-image?query=Film%20set%20director%20chair%20under%20spotlight%20on%20empty%20stage%2C%20dramatic%20single%20light%20source%2C%20dark%20surroundings%2C%20abandoned%20feeling%2C%20cinematic%20drama%2C%20high%20contrast%20black%20and%20warm%20amber%20tones&width=600&height=400&seq=carousel-06&orientation=landscape',
    date: '2026-07-25',
    views: '203.1万',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            重磅深扒
          </h2>
          <p className="text-foreground-500 text-sm">焦点专题 · 深度追踪报道</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {items.map((item, i) => (
            <article
              key={i}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={i > 2 ? 'lazy' : undefined}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-white text-xs font-medium rounded-md whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-bold text-foreground-950 mb-3 leading-snug line-clamp-2 font-heading">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{item.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}